import { useContext } from 'react';

import useFeatureFlagsSwitcher from '../useFeatureFlagsSwitcher';
import { canAccessInternationalTransferContext } from './canAccessInternationalTransferContext';

export const useInternationalTransferFeature = () => {
  const { featureFlags } = useFeatureFlagsSwitcher();
  const { canAccessInternationalTransfer } = useContext(
    canAccessInternationalTransferContext,
  );

  return {
    canAccessInternationalTransfer:
      featureFlags.enableInternationalTransfer ||
      canAccessInternationalTransfer,
  };
};
